const MVCObject = require("../mvcobject").MVCObject;
const geometry = require("../maps/geometry");
const utils = require("../maps/utils");
/**
 * Constructs a new DistanceProvider. It should be bound to a location property or it needs to be set manually.
 * @constructor
 * @param {Object} [options] optionals options to DistanceMatrixService {@link https://developers.google.com/maps/documentation/javascript/distancematrix|DistanceMatrix Doc}
 * @extends woosmap.utils.MVCObject
 * @memberOf woosmap.location
 */
const DistanceProvider = function (options) {
    options = options || { travelMode: "DRIVING" };

    /**
     * The location to compute a distance from. This property is bindable.
     * @see woosmap.utils.MVCObject#bindTo
     * @type {LatLngLiteral}
     */
    this.location = null;
    this.options = options;
};

DistanceProvider.prototype = new MVCObject();

/**
 * This method updates or adds the following properties of each `stores` in the array :
 *
 * - `duration`: the duration in seconds.
 * - `distance`: the distance in meters.
 * - `duration_text`: a String representation of the duration.
 * - `distance_text`: A string representation of the distance value, using the `unitSystem` specified in the constructor options.
 *
 * @param {Array.<Store>} stores the stores array to be updated
 * @param {Function} user_callback the callback method which will be called with the new store's array
 * @param {String} orderby should be distance or duration. By default it will use distance.
 */
DistanceProvider.prototype.updateStoresDistanceWithGoogle = function (stores, user_callback, orderby) {
    if (this.get("location") && stores && stores.length > 0) {
        const self = this;
        const origin = new geometry.LatLng(this.get("location").lat, this.get("location").lng);
        const destinations = this._extract_stores_geometry(stores);
        const options = this.options;
        options.origins = [origin];
        options.destinations = destinations;
        orderby = orderby || "distance";

        function callback(response, status) {
            if (status === "OK") {
                stores = self._update_stores_values(stores, response.rows[0].elements);
                stores.sort((a, b) => {
                    if (a.properties[orderby] === b.properties[orderby]) return 0;
                    if (a.properties[orderby] > b.properties[orderby]) return 1;
                    return -1;
                });
                user_callback(stores);
            } else {
                if (!(typeof console === "undefined" || typeof console.error === "undefined")) {
                    console.error("Google Distance Matrix Service Error : ", status);
                }
            }
        }

        const service = new google.maps.DistanceMatrixService();
        service.getDistanceMatrix(options, callback);
    } else {
        if (!(typeof console === "undefined" || typeof console.error === "undefined")) {
            console.error("DistanceProvider Error : No stores");
        }
        user_callback(stores);
    }
};

DistanceProvider.prototype._update_stores_values = (input_stores, results) => {
    for (let j = 0; j < results.length; j++) {
        if (results[j].status === "OK") {
            input_stores[j].properties.distance = results[j].distance.value;
            input_stores[j].properties.duration = results[j].duration.value;
            input_stores[j].properties.distance_text = results[j].distance.text;
            input_stores[j].properties.duration_text = results[j].duration.text;
        }
    }
    return input_stores;
};

DistanceProvider.prototype._extract_stores_geometry = (stores) => {
    const destinations = [];
    for (let i = 0, ln = stores.length; i < ln; i++) {
        destinations.push(new google.maps.LatLng(stores[i].geometry.coordinates[1], stores[i].geometry.coordinates[0]));
    }
    return destinations;
};

exports.DistanceProvider = DistanceProvider;
